import { render, staticRenderFns } from "./MotorProposalGeneral.vue?vue&type=template&id=646d4ae9&"
import script from "./MotorProposalGeneral.vue?vue&type=script&lang=js&"
export * from "./MotorProposalGeneral.vue?vue&type=script&lang=js&"
import style0 from "./MotorProposalGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorProposalGeneral.vue"
export default component.exports